<template lang="html">

<div class="buildingList">

      <!-- 查看 -->
      <el-row class="seekLine">

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">楼宇名称：</div>
              <div class="inpContent">
                   <el-input clearable @input="reList" v-model="params.buildingName" size="medium" placeholder="请输入内容" />
              </div>

         </el-col>

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">所在街乡：</div>
              <div class="inpContent">
                  <tree-select
                       code="szjx"
                       paramsKey="jiexiang"
                       :moreSelect="true"
                       :selectId="params.jiexiangId"
                       @selectChange="selectChange"
                       plaText="所在街乡" />
              </div>

         </el-col>

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">定位：</div>
              <div class="inpContent">
                   <dic-select code="dw"
                        paramsKey="location"
                        :selectId="params.locationId"
                        @selectChange="selectChange"
                        plaText="定位" />
              </div>

         </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">所属功能区：</div>
              <div class="inpContent">
                   <dic-select code="ssgnyq"
                      paramsKey="park"
                      :selectId="params.parkId"
                      plaText="所属功能区"
                      @selectChange="selectChange" />
              </div>

         </el-col>

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">当前空置可招商面积：</div>
              <div class="inpContent">
                  <el-select clearable @change="areaChange" v-model="areaKey" size="medium" placeholder="请选择">
                     <el-option
                       v-for="item in areaOptions"
                       :key="item.val"
                       :label="item.name"
                       :value="item.val">
                     </el-option>
                   </el-select>
              </div>

         </el-col>

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName">项目类型：</div>
              <div class="inpContent">
                    <dic-select code="xmlx"
                       paramsKey="projectType"
                       :selectId="params.projectTypeId"
                       plaText="项目类型"
                       @selectChange="selectChange" />
              </div>

         </el-col>

         <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6" class="inpItem">

              <div class="inpName"></div>
              <div class="inpContent">
                  <el-button @click="cleanSeek" style="width:90px;" size="small">重置</el-button>
              </div>

         </el-col>

      </el-row>

      <div class="pgContent">

           <el-radio-group @change="stateChange" class="stateLine" v-model="stateKey">
               <el-radio-button v-for="item in stateArr" :label="item"></el-radio-button>
           </el-radio-group>

           <el-table border
               header-cell-class-name="dHead"
               v-loading="loading"
               :data="tbData">

               <el-table-column fixed="left" align="center" width="60" label="序号">
                   <template slot-scope="scope">
                        {{ scope.$index + (params.no - 1)*params.size + 1 }}
                   </template>
               </el-table-column>
               <el-table-column prop="buildingName" fixed="left" align="center" min-width="150" label="楼宇名称" />
               <el-table-column prop="tenement" align="center" width="120" label="物业单位" />
               <el-table-column prop="propertyUnit" align="center" min-width="120" label="产权单位" />
               <el-table-column prop="jiexiang" align="center" width="90" label="所属街乡" />
               <el-table-column prop="address" align="center" min-width="150" label="地址">
                   <template slot-scope="scope">
                        {{ scope.row.address | adsTrans }}
                   </template>
               </el-table-column>
               
               <el-table-column prop="park" align="center" width="150" label="所属功能区" />
               <el-table-column prop="projectType" align="center" width="120" label="项目类型" />
               <el-table-column prop="nationalized" align="center" width="120" label="是否国有" />
               <el-table-column prop="location" align="center" width="120" label="产业定位" />
               
                <el-table-column prop="isWillingCityPlatformReleaseRecommend" align="center" width="150" label="是否愿意在市级平台对外发布推介" />
               <el-table-column prop="isWillingDistrictInvestmentWorkeleaseRecommend" align="center" width="120" label="是否愿意在区级招商工作中对外发布推介" />
               <el-table-column prop="notPublishReason" align="center" width="120" label="不希望对外发布的原因" />
               <el-table-column prop="isWillingUndertakeInterOrganizationWorkspace" align="center" width="120" label="是否愿意承接国际组织办公场所" />
               <el-table-column prop="planBuildingArea" align="center" width="120" label="规划建筑面积(平方米)" />
               <el-table-column prop="totalVacantArea" align="center" width="150" label="当前空置可招商面积(平方米)" />
               

               <el-table-column prop="leadingCadre" align="center" width="120" label="招商负责人" />
               <el-table-column prop="leadingCadrePhone" align="center" width="150" label="负责人手机号" />
               <el-table-column prop="leadingCadreEmail" align="center" width="120" label="负责人邮箱" />

               <el-table-column align="center" width="120" label="图片">
                   <template slot-scope="scope">
                       <span @click="goview(scope.row)" class="ibtn">查看</span>
                   </template>
               </el-table-column>
               <el-table-column prop="uploadUser" align="center" width="90" label="上传用户" />
               <el-table-column prop="createdAt" align="center" width="180" label="上传时间" />
               <el-table-column prop="status" align="center" width="90" label="状态" fixed="right" >
                   <template slot-scope="scope">
                       {{ scope.row.status | statusTrans }}
                   </template>
               </el-table-column>
               <!-- 编辑 -->
               <el-table-column align="center" width="150" fixed="right" label="操作">
                   <template slot-scope="scope">
                       <template v-if="scope.row.status==1||scope.row.status==3||scope.row.status==5">
                           <span @click="goInner(scope.row,1)" class="ibtn">查看</span>
                       </template>
                       <template v-else>
                            <span @click="goInner(scope.row,1)" class="ibtn">查看</span>
                            <template v-if="scope.row.status != 1">
                                <span @click="goInner(scope.row,2)" class="ibtn">编辑</span>
                                <span @click="goInner(scope.row,3)" class="ibtn">删除</span>
                            </template>
                       </template>
                        
                   </template>
               </el-table-column>

           </el-table>

           <div class="table-footer">

              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="pageChange"
                :current-page="params.no"
                :page-size="params.size"
                layout="total, prev, pager, next, jumper"
                :total="params.allEls">
              </el-pagination>

          </div>

          <el-image
            ref="elImage"
            style="width: 0px; height: 0px"
            :src="url"
            :preview-src-list="srcList"
          />


      </div>

</div>

</template>

<script>
import { getBuildings,removeBuilding } from '@/api/industryInfos';
import { getViewKey } from '@/api/account';
import { mapGetters } from 'vuex';
export default {
    filters:{
      adsTrans(e){
          let arr = e.split(',');
          if(arr[2]){
              return arr[0] + arr[2];
          }else{
              return arr[0];
          }
      },
      statusTrans(e){
          console.log(4);
          let map = {
              '全部':'4,1,3,5,2,6',
              '未提交':'4',
              '待审核':'1,3,5',
              '通过':'2',
              '退回':'6'
           };
           var index=0;
           if(e===4){
                index=1;
           }
           if(e===1||e===3||e===5){
                index=2;
           }
           if(e===2){
                index=3;
           }
           if(e===6){
                index=4;
           }
          let arr=['','未提交','待审核','通过','退回'];
          return arr[index];
      }
    },
    computed:{
      ...mapGetters(['userInfo'])
   },
    data(){
        return{
            tbData:[],

            areaOptions:[
               { name:'不限',val:0 },
               { name:'1000 ㎡以下',val:1 },
               { name:'1000-3000 ㎡',val:2 },
               { name:'3000-5000 ㎡',val:3 },
               { name:'5000-10000 ㎡',val:4 },
               { name:'10000-30000 ㎡',val:5 },
               { name:'30000-50000 ㎡',val:6 },
               { name:'50000 ㎡以上',val:7 }
            ],
            areaKey:null,

            stateArr:['全部','未提交','待审核','通过','退回'],
            stateKey:'全部',

            loading:false,

            jxids:[],

            allPages:0,
            params:{
                buildingName:'',
                jiexiangId:'',
                locationId:'',
                parkId:'',
                totalVacantArea1:'',
                totalVacantArea2:'',
                status:'',
                userId:'',
                no:1,
                size:10,
                allEls:0
            },

            url:'',
            srcList:[]
        }
    },
    methods:{
        selectChange(e){
           this.params[e.paramsKey + 'Id'] = e.id;
           this.reList();
        },

        areaChange(e){
           let map = {
               1: [0,1000],
               2: [1000,3000],
               3: [3000,5000],
               4: [5000,10000],
               5: [10000,30000],
               6: [30000,50000],
               7: [50000,'']
           }
           if(e){
             this.params.totalVacantArea1 = map[e][0];
             this.params.totalVacantArea2 = map[e][1];
           }else{
             this.params.totalVacantArea1 = '';
             this.params.totalVacantArea2 = '';
           }
           this.reList();
        },

        stateChange(e){
           let map = {
              '全部':'4,1,3,5,2,6',
              '未提交':'4',
              '待审核':'1,3,5',
              '通过':'2',
              '退回':'6'
           };
           this.params.status = map[e];
           this.reList();
        },

        cleanSeek(){
           let arr = ['no','size','allEls','status'];
           let vues = this;
           for(let key in this.params){
               if(arr.indexOf(key) < 0){
                  vues.params[key] = ''
               };
           };
           this.areaKey = null;
           this.reList();
        },

        pageChange(e){
           this.params.no = e;
           this.getList();
        },

        getList(){
            this.loading = true;
            // console.log(this.userInfo);
            this.params.userId=this.userInfo.userId;
            getBuildings(this.params).then(res => {
                this.loading = false;
                this.tbData = res.industrialSpaceList;
                this.params.allEls = res.totalElements;
                this.allPages = res.totalPages;
            })
        },

        reList:function(){
            this.params.no = 1;
            this.getList();
        },

        goview(row){
            if(this.viewDat){
                let vues = this;

                if(row.image){
                   let imgs = JSON.parse(row.image);
                   vues.srcList = [];
                   imgs.forEach(item => {
                       let url = vues.viewDat.imagePreUrl + '/id/' + item.id + '/token/' + vues.viewDat.token;
                       vues.srcList.push(url);
                   });
                   vues.$nextTick(() => {
                       vues.$refs.elImage.clickHandler();
                   })
                }
            }else{
               this.$message.error('初始化未完成！');
            }
        },

        goInner(row,type){
            let vues = this;
            console.log(row);
         // type 1 查看 2 编辑 3 删除
            if(type == 1){
                 this.$router.push({
                     path:'bulidingInfos',
                     query:{
                         id:row.id
                     }
                 });
            }else if(type == 2){
                  this.$router.push({
                      path:'bulidingEdit',
                      query:{
                          id:row.id
                      }
                  });
            }else if(type == 3){
              this.$confirm(
                  '确认删除吗?',
                  '提示',
                  { type: 'warning'}
              ).then(() => {
                  removeBuilding({id:row.id}).then(res => {
                      vues.reList();
                  })
              })
            }
        }
    },
    created(){
       this.getList();

       getViewKey().then(res => {
           this.viewDat = {
               imagePreUrl:res.imagePreUrl,
               token:res.token
           };
       })
    }
}
</script>

<style lang="scss" scoped>

.buildingList{
    font-size: 15px;

    .headLine{
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #EBEEF5;
    }
    .navLine{
       padding-left: 20px;
       border-bottom: 1px solid #EBEEF5;
       .navItem{
           height: 54px;
           font-size: 14px;
           margin-left: 30px;
           display: inline-block;
           line-height: 54px;
           border-bottom: 2px solid white;
           cursor: pointer;
           &.act{
              color: #409EFF;
              border-color: #409EFF;
           }
       }
    }
    .seekLine{
        padding: 20px;
        padding-bottom: 0px;
        border-bottom: 1px solid #EBEEF5;
        .inpItem{
            padding-right: 20px;
            margin-bottom: 20px;
            .inpName{
                width: 120px;
                float: left;
                font-size: 14px;
                text-align: right;
                padding-top: 6px;
            }
            .inpContent{
                margin-left: 120px;
                .el-select{
                    display: block;
                }
                .el-cascader{
                    display: block;
                }
            }
        }

    }

    .btnLine{
        padding: 20px;
        padding-bottom: 0px;
    }

    .pgContent{
         padding: 20px;

         .stateLine{
             margin-bottom: 6px;
         }

        .table-footer{
            margin-top: 20px;
            text-align: right;
        }

        .ibtn{
            cursor: pointer;
            font-size: 13px;
            margin: 0 3px;
        }

        .ibtn:nth-child(1){
            color: #409EFF;
        }
        .ibtn:nth-child(2){
            color: #E6A23C;
        }
        .ibtn:nth-child(3){
            color: #F56C6C;
        }
    }

}

</style>

<style lang="scss">

#buildings{
    .el-input__inner{
        border-radius: 0px;
    }
    .dHead{
        background: #f5f5f5;
        font-weight: normal;
    }

}

</style>



// WEBPACK FOOTER //
// buildingList.vue?33df3adf